import React from 'react';
import { withTranslation } from 'react-i18next';
import { DeepLinkBlock, ComponentHeader } from './style';
import { BasicView } from '../BasicView';
import { StripesView } from '../StripesView';
import { CollapseView } from '../CollapseView';
import { BackRightIcon } from './Icons/BackRightIcon';
import { BackLeftIcon } from './Icons/BackLeftIcon';
import { connect } from 'react-redux';
import { TextButton } from 'wix-ui-tpa';
import LinesEllipsis from 'react-lines-ellipsis';
import triggerEvent from '../../../../../../services/bi/biSiteLogger';
import triggerEventSeo from '../../../../../../services/bi/biSiteSeoLogger';

import biData from '../../../../../../services/bi/biEvents.json';
import wixService from '../../../../../../services/wixService';

class DeepLinkView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeepLink: true,
    };

  wixService.getSiteInfo((siteInfo) => {
    
    biData.UOU_EXPENDS_A_QUESTION = {
      ...biData.UOU_EXPENDS_A_QUESTION,
      type: 'deep link',
      question_id: props.questions[0].id,
      category_id: props.questions[0].categoryId,
      question_order: props.questions[0].sortOrder,
      question_name: props.questions[0].question,
      url: siteInfo && siteInfo.url ? siteInfo.url: ''
    };
    biData.UOU_EXPENDS_A_QUESTION_SEO = {
      ...biData.UOU_EXPENDS_A_QUESTION_SEO,
      elementTitle: props.questions[0].question,
      url: siteInfo && siteInfo.url ? siteInfo.url: '',
      language:this.props?.settings?.language
    };

    triggerEvent(biData.UOU_EXPENDS_A_QUESTION); 
    triggerEventSeo(biData.UOU_EXPENDS_A_QUESTION_SEO); 
  });

  }
  componentDidMount(){
     const element = document.getElementById('aaa');
     setTimeout(() => {
       element && element.scrollIntoView({behavior:'smooth',block:'nearest'});
     },500)
  }
  render() {
    const { questions, settings, design, styleParams, t } = this.props;
    return (
      <>
        {this.state.showDeepLink && questions.length > 0 && (
          <DeepLinkBlock
            design={design}
            styleParams={styleParams}
            dir={settings.direction}
          >
            <div className="inSide">
              <div className="title">
                <LinesEllipsis
                  text={t(settings.title.text)}
                  maxLine={3}
                  ellipsis="..."
                  trimRight={true}
                  component="div"
                  basedOn="letters"
                  style={{ textAlign: 'center', width: '100%' }}
                />
              </div>
              <ComponentHeader className="component-header" design={design}>
                <TextButton
                  className={
                    'btn-container ' +
                    (settings.isRTL ? 'right-content' : 'left-content')
                  }
                  priority="secondary"
                  prefixIcon={
                    settings.isRTL ? <BackRightIcon /> : <BackLeftIcon />
                  }
                  onClick={() => this.setState({ showDeepLink: false })}
                  aria-label={t('deepLink.back.btn')}
                  aria-labelledby="tab_0"
                  children={t('deepLink.back.btn')}
                />
              </ComponentHeader>

              <div className="component-main">
                {settings.isBasic && (
                  <BasicView
                    className="question-basic-view"
                    questions={questions}
                  />
                )}
                {settings.isStripes && (
                  <StripesView
                    className="question-stripes-view"
                    questions={questions}
                    isDeepLink={true}
                  />
                )}

                {settings.isCollapse && (
                  <CollapseView questions={questions} isDeepLink={true} />
                )}
              </div>
            </div>
          </DeepLinkBlock>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state,
  };
}

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(DeepLinkView));
